import React from "react";

import { Image } from "@/components/atoms/Image";

import { useHeroBannerList } from "./useHeroBannerList";

const HeroBanner = () => {
  const items = useHeroBannerList();

  return (
    <div className="tw-flex tw-justify-center tw-gap-24 tw-items-center tw-h-[384px] lg:tw-h-[636px] tw-pt-32 tw-pb-32 lg:tw-pb-56">
      {items.map(
        ({
          id: heroBannerItemId,
          heroBannerItemImageSrc,
          heroBannerItemImageAlt,
        }) => (
          <div
            key={heroBannerItemId}
            className="lg:tw-min-w-[460px] tw-min-w-[260px] tw-h-full tw-rounded-[4.5px] tw-overflow-hidden tw-select-none tw-pointer-events-none"
            style={{
              boxShadow: "0 15.296px 45.887px 0 rgba(18, 18, 18, 0.12)",
            }}
          >
            <Image
              src={heroBannerItemImageSrc}
              alt={heroBannerItemImageAlt}
              fetchPriority="high"
            />
          </div>
        ),
      )}
    </div>
  );
};

export { HeroBanner };
